import { render, staticRenderFns } from "./other-initiatives.vue?vue&type=template&id=15ae4d6f&"
import script from "./other-initiatives.vue?vue&type=script&lang=js&"
export * from "./other-initiatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports